const ModeReducer = (state=false,action)=>{
    if(action.type==='MODE'){
        return !state;
    }
    return state
}

export default ModeReducer